import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExperianHeaderModule, CardListViewModule, HomeNotificationsModule } from '@experian/header'; // NOSONAR
import { FooterModule, ModalModule } from '@experian-shared'; // NOSONAR
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { environment } from '../../../environments/environment';
import { DashboardComponent } from './dashboard.component';
import { TourMockupComponent } from '../tour/tour.component';
import { ButtonSerasaAlertaComponent } from '../button-serasa-alerta/button-serasa-alerta.component';
import { AnalyticsButtonDirective } from '../../shared/directives/analytics-button.directive';
import { CanActivateDashboard } from '../../services/dashboard-activate-guard.service';
import { ModalFirstAccessSerasaAlertaComponent } from '../modal-first-access-serasa-alerta/modal-first-access-serasa-alerta.component';
import { TermsGuard } from './../../guards/terms.guard';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [TermsGuard, () => {
      inject(CanActivateDashboard).canActivate()
    }],
  },
];

@NgModule({
  declarations: [
    AnalyticsButtonDirective,
    ButtonSerasaAlertaComponent,
    DashboardComponent,
    ModalFirstAccessSerasaAlertaComponent,
    TourMockupComponent,
  ],
  imports: [
    CardListViewModule,
    CommonModule,
    ExperianHeaderModule.forRoot(environment),
    FooterModule,
    GuidedTourModule,
    HomeNotificationsModule,
    MatDialogModule,
    MatIconModule,
    ModalModule,
    RouterModule.forRoot(routes),
  ],
  exports: [
    RouterModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    GuidedTourService,
  ]
})
export class DashboardModule { }
